import * as React from "react";
import type { SVGProps } from "react";

interface GoalProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Goal = ({ cancelled = false, ...props }: GoalProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none">
      <path
        fill="#FFF"
        d="M11.87 4.85C6.02 4.85.85 6.57.85 9.94v5.47l.12.35c1 2.81 5.49 4.39 10.9 4.39 5.34 0 10.1-1.9 10.94-4.83l.09-.3V9.4c0-3.38-4.6-4.54-11.03-4.54Zm0 2.15c4.7 0 8.88.9 8.88 2.4v5.32C20.3 16.28 16.69 18 11.87 18 7.06 18 3.56 16.6 3 15.04v-5.1C3 8.44 7 7.06 11.57 7z"
      />
      <path
        fill="#000"
        d="M11.87 5.7C6.48 5.7 1.7 7.29 1.7 9.94v5.32l.08.21c.83 2.36 5 3.83 10.1 3.83 4.99 0 9.42-1.77 10.12-4.22l.05-.17V9.39c0-2.6-4.3-3.69-10.18-3.69"
      />
      <path
        fill="#6F6F6F"
        d="M11.87 7c4.7 0 8.88.9 8.88 2.4v5.32C20.3 16.28 16.69 18 11.87 18 7.06 18 3.56 16.6 3 15.04v-5.1C3 8.44 7 7.06 11.57 7z"
      />
      <path
        fill="#000"
        d="M11.87 5.7C6.48 5.7 1.7 7.29 1.7 9.94c0 2.63 3.64 3.34 10.17 3.34 5.65 0 10.18-1.28 10.18-3.89 0-2.6-4.3-3.69-10.18-3.69"
      />
      <path
        fill="#BDBDBD"
        d="M11.87 7c4.7 0 8.88.9 8.88 2.4s-4.18 2.58-8.88 2.58h-.6C6.81 11.94 3 11.4 3 9.94 3 8.44 7 7.06 11.57 7z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Goal;
